import { Link } from 'react-router-dom';
import './legal.css';

function BackArrow() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M15.5 18.5L8.5 12l7-7.5"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const ITEMS = [
  {
    q: 'How do I place a delivery?',
    a: 'From Home, tap Deliver, enter the pickup and drop-off, then confirm the package details and book.',
  },
  {
    q: 'How do I track my order?',
    a: 'Open Orders and tap the delivery: it shows each step, and your rider on the map once one is on the way.',
  },
  {
    q: 'Which payment methods are supported?',
    a: 'Cash: you pay the rider the price you booked at, at drop-off.',
  },
  {
    q: 'How do I update my profile?',
    a: 'Go to Profile, open Personal information, change your details and save.',
  },
  {
    q: 'I can’t log in — what should I check?',
    a: 'Use the email and password you registered with. If you have forgotten the password, tap Forgot password? on the sign-in screen.',
  },
  {
    q: 'Who do I contact for help?',
    a: 'Go to Profile, then Help & support, to call, WhatsApp or email the InGo office.',
  },
];

export default function FAQsPage() {
  return (
    <main className="legal-page">
      <div className="legal-card legal-card--pad-top">
        <header className="legal-top">
          <Link to="/profile" className="legal-back" aria-label="Back to profile">
            <BackArrow />
          </Link>
          <h1 className="legal-top__title">FAQs</h1>
          <span className="legal-top__spacer" aria-hidden />
        </header>


        <div className="legal-faq-list">
          {ITEMS.map(({ q, a }) => (
            <details key={q} className="legal-faq">
              <summary className="legal-faq__q">{q}</summary>
              <p className="legal-faq__a">{a}</p>
            </details>
          ))}
        </div>

        <p className="legal-footnote">
          Still stuck?{' '}
          <Link to="/help-support" className="legal-inline-link">
            Help &amp; Support
          </Link>
        </p>
      </div>
    </main>
  );
}
